const chessOpponents = [
  {
    name: "Rahul Sharma",
    avatar: "https://i.pravatar.cc/150?img=11",
  },
  {
    name: "Aman Verma",
    avatar: "https://i.pravatar.cc/150?img=12",
  },
  {
    name: "Arjun Singh",
    avatar: "https://i.pravatar.cc/150?img=13",
  },
  {
    name: "Rohan Kumar",
    avatar: "https://i.pravatar.cc/150?img=14",
  },
  {
    name: "Vikram Mehta",
    avatar: "https://i.pravatar.cc/150?img=15",
  },
  {
    name: "Karan Patel",
    avatar: "https://i.pravatar.cc/150?img=16",
  },
  {
    name: "Aditya Roy",
    avatar: "https://i.pravatar.cc/150?img=17",
  },
  {
    name: "Sahil Gupta",
    avatar: "https://i.pravatar.cc/150?img=18",
  },
];

export const getRandomOpponent = () => {
  const index = Math.floor(
    Math.random() * chessOpponents.length
  );

  return chessOpponents[index];
};

export default chessOpponents;